<div class="container">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ headerTitle | globalTranslate }}</h1>
    </div>
  </div>
  <nh-alert type="success" [isOpen]="isMailSent">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../../assets/images/Icons/⚛️ icons-checkmark-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "NEW_VERIFICATION_LINK" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  @if (!displayEbmsContent) {
  <div class="card mb-5" style="border: 0px">
    <div class="card-body shadow-sm">
      <h2 class="section-header">{{ sectionTitle | globalTranslate }}</h2>
      <hr />
      @if (isRegisterAccountLinkValid) {
      <section>
        <p>{{ "REGISTRATION_LINK_SUCC_BODY_TEXT" | globalTranslate }}</p>
        <div class="pt-1 hover-red comments">
          <a class="btn btn-link hover-red ps-0" [routerLink]="['/signin']">
            <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
            <nh-exit-svg></nh-exit-svg>
          </a>
        </div>
      </section>
      } @if (isRegisterAccountLinkValid !== undefined &&
      !isRegisterAccountLinkValid) {
      <section>
        <p>{{ "REGISTRATION_LINK_EXP_BODY_TEXT" | globalTranslate }}</p>
        <div class="pt-1 hover-red comments">
          <a class="btn btn-link hover-red ps-0" [routerLink]="['/signin']">
            <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
            <nh-exit-svg></nh-exit-svg>
          </a>
        </div>
      </section>
      }
    </div>
  </div>
  } @if (displayEbmsContent) {
  <div class="card mb-5" style="border: 0px">
    <div class="card-body shadow-sm">
      <h2 class="section-header">{{ sectionTitle | globalTranslate }}</h2>
      <hr />
      @if (isRegisterAccountLinkValid) {
      <section>
        <p
          [innerHTML]="
            'REGISTRATION_LINK_VERIFIED_PREVIOUSLY' | globalTranslate
          "
        ></p>
        <div class="pt-1 hover-red comments">
          <a class="btn btn-link hover-red ps-0" [routerLink]="['/signin']">
            <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
            <nh-exit-svg></nh-exit-svg>
          </a>
        </div>
      </section>
      } @if (isRegisterAccountLinkValid !== undefined &&
      !isRegisterAccountLinkValid) {
      <section>
        <p
          [innerHTML]="'REGISTRATION_LINK_EXP_BODY_TEXT_EBMS' | globalTranslate"
        ></p>
        <div class="pt-1 hover-red comments">
          <a class="btn btn-link hover-red" (click)="emailMe()">
            <span class="pe-2">{{ "EMAIL_ME" | globalTranslate }}</span>
            <nh-exit-svg></nh-exit-svg>
          </a>
        </div>
      </section>
      }
    </div>
  </div>
  }
</div>